import "./Header.css";

function Header() {
  return (
    <div className="header">
      <h1 className="header__title">Todo List</h1>
    </div>
  );
}

export default Header;
